export default {
      id: "reduce-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#reduce",
      toString: function () {
        return this.url;
      }
    }